module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"criterion":"Criterion","false":"No","selectCriterion":"Select a criterion","true":"Yes"},"fr":{"criterion":"Critère","false":"Non","selectCriterion":"Sélectionner un critère","true":"Oui"}}')
  delete Component.options._Ctor
}
